var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var activityReducer = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'TRACK_EXPANDED': {
            return __assign(__assign({}, state), (_a = {}, _a[action.payload.channelId] = __spreadArray(__spreadArray([], (state[action.payload.channelId] || [])), [action.payload.trackId]), _a));
        }
        case 'TRACK_COLLAPSED': {
            return __assign(__assign({}, state), (_b = {}, _b[action.payload.channelId] = (state[action.payload.channelId] || []).filter(function (id) { return id !== action.payload.trackId; }), _b));
        }
        default: {
            return state;
        }
    }
};
export default activityReducer;



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/activity.reducer.ts
// module id = 1460
// module chunks = 81